/** @module api/ems_current_status */

import { apiCall } from '@/api/index'
import { apiV1EmsCurrentStatusesPath, apiV1EmsCurrentStatusPath } from '@/../lib/routes'

export function getEmsCurrentStatus({ ctxt }) {
  return apiCall({
    path: apiV1EmsCurrentStatusesPath(ctxt),
    payload: {}
  })
}

export function updateEmsCurrentStatus({ ctxt = 'customer', emsId, attributes } = {}) {
  const payload = {
    data: {
      type: 'ems_current_statuses',
      id: emsId,
      attributes
    }
  }

  return apiCall({
    method: 'PATCH',
    path: apiV1EmsCurrentStatusPath(ctxt, emsId),
    payload
  })
}
